import { render, staticRenderFns } from "./FormProjectEditGeneral.vue?vue&type=template&id=a6d6af7c"
import script from "./FormProjectEditGeneral.vue?vue&type=script&lang=ts"
export * from "./FormProjectEditGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports